var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["LOCAL"] = "local";
  Environment2["STAGING"] = "staging";
  Environment2["TESTING"] = "testing";
  Environment2["CYPRESS_TEST"] = "cypress_test";
  Environment2["EPHEMERAL"] = "ephemeral";
  Environment2["PRODUCTION"] = "production";
  Environment2["UNKNOWN"] = "unknown";
  return Environment2;
})(Environment || {});
export {
  Environment as E
};
//# sourceMappingURL=environment-BHIxEh0R.js.map
